export default "__VITE_ASSET__DRPYQxSM__"